export default "__VITE_ASSET__CalqHuxF__"